"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    _ref$palette = _ref.palette,
    text = _ref$palette.text,
    primary = _ref$palette.primary,
    shade = _ref.utils.shade;
  return {
    '@global': {
      '.MuiPickersBasePicker-container': {
        height: '285px',
        '& > .MuiPickersToolbar-toolbar': {
          backgroundColor: '#F7F7F7',
          '&.MuiPickersToolbar-toolbarLandscape': {
            maxWidth: '130px'
          },
          '& > button > span > h6': {
            color: 'rgba(34,34,34,0.5)',
            fontSize: '14px'
          },
          '& > button > span > h4': {
            color: '#222222',
            fontWeight: typography.fontWeightLight,
            fontSize: '22px'
          }
        }
      }
    },
    root: {
      display: 'inline-block',
      position: 'relative',
      '& > div': {
        width: '275px',
        '& > div.MuiInput-underline': {
          '&:before': {
            borderBottom: 'none'
          },
          '&:after': {
            borderBottom: 'none'
          },
          '&:hover:not(.Mui-disabled):before': {
            borderBottom: 'none'
          }
        }
      },
      '& label': {
        fontSize: '14px',
        marginBottom: '7px',
        '&.Mui-focused': {
          color: 'initial'
        }
      },
      '& input': {
        maxHeight: '50px',
        backgroundColor: '#F7F7F7',
        borderRadius: '5px',
        padding: '16px 40px',
        border: 'none'
      },
      '& > svg': {
        width: '12px',
        height: '14px',
        color: '#1E8777',
        position: 'absolute',
        left: '20px',
        bottom: 'calc(25px - 7px)'
      }
    }
  };
}, {
  name: 'APDatePicker'
});
exports.useStyles = useStyles;